import styled from 'styled-components';

import { Image } from 'components/Image';

const Container = styled.div`
  position: relative;

  display: flex;

  padding-bottom: 3rem;

  input {
    width: 4.5rem;
  }
`;

const ImageContainer = styled.div`
  width: 25rem;
`;

const Img = styled(Image)`
  width: 20rem;
  margin-left: 4rem;
`;

export { Container, ImageContainer, Img };
